import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const useAuth = () => {
    const context = useContext(AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};

// Decode payload của JWT (không verify chữ ký — chỉ để đọc info + exp ở client)
const decodeToken = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.exp && payload.exp * 1000 < Date.now()) return null; // hết hạn
        return payload;
    } catch {
        return null;
    }
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    // Khôi phục phiên đăng nhập từ token trong localStorage khi load app
    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            const payload = decodeToken(token);
            if (payload) {
                setUser(payload);
            } else {
                localStorage.removeItem('token'); // token hỏng/hết hạn
            }
        }
        setLoading(false);
    }, []);

    // Gọi từ AuthCallback sau khi OAuth trả token về
    const login = (token, payload) => {
        localStorage.setItem('token', token);
        setUser(payload || decodeToken(token));
    };

    const logout = () => {
        localStorage.removeItem('token');
        setUser(null);
    };

    const value = {
        user,
        loading,
        isAuthenticated: !!user,
        login,
        logout,
        checkAuth: () => {}
    };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthContext;
